module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_with_news_big_cn.128c9549.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_with_news_big_cn.jpg
// module id = 2980
// module chunks = 11